export default __webpack_public_path__ + "static/media/asset-3.ff8fba41.webp";